// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","logo":"Navbar_logo__MK0b0","logo__react":"Navbar_logo__react__FwYU9","link":"Navbar_link__zGYRb"};